const AppConfig = {
  auth: {
    isLoggedIn: 'loggedInRussia5G',
    accessToken: 'accessTokenRussia5G',
    userRole: 'userRole'
  }
}

export default AppConfig;
